// extracted by mini-css-extract-plugin
export var footer = "_qa-5";
export var fulfillmentInput = "_qa-0";
export var shipDateInput = "_qa-1";
export var shipmentModal = "_qa-2";
export var shipmentModalContent = "_qa-3";
export var tableContainer = "_qa-4";